<template>
    <div>
        <el-form-item label="Tekst" required
                      :error="errors[addLanguageSuffix('text')]">
            <wyswig-input v-model="form[addLanguageSuffix('text')]"/>
        </el-form-item>
        <div class="slides">
            <el-collapse class="formset__list">
                <div v-for="slide, i in form.slides" class="formset__item">
                    <el-collapse-item :name="i">
                        <template slot="title">
                            <formset-header :label="`${slide.title_pl || 'Slajd'}`"
                                            :errors="checkForErrors(errors.slides, [i])"
                                            :items.sync="form.slides"
                                            :index="i"/>
                        </template>
                        <div class="inline-form-group">
                            <el-form-item label="Zdjęcie"
                                          :error="errors.slides && errors.slides[i] && errors.slides[i]['photo']">
                                <image-input-component v-model="slide.photo"/>
                            </el-form-item>
                            <el-form-item label="Kolor tekstu"
                                          :error="errors.slides && errors.slides[i] && errors.slides[i]['text_color']">
                                <el-color-picker v-model="slide.text_color"/>
                            </el-form-item>
                        </div>
                    </el-collapse-item>
                </div>
            </el-collapse>
            <el-button @click="addSection">Dodaj slajd</el-button>
            <div v-if="typeof errors.slides === 'string'" class="el-form-item__error">
                {{ errors.slides }}
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['form', 'errors'],
        methods: {
            addSection () {
                const blankObject = {}
                if (!Array.isArray(this.form.slides)) {
                    this.$emit('update:form', {
                        ...this.form,
                        slides: [
                            blankObject
                        ]
                    })
                } else {
                    this.form.slides.push(blankObject)
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    .slides {
        position: relative;
    }
</style>


// WEBPACK FOOTER //
// PhotoWithTextWidget.vue?fa20b83e